<template>
  <v-dialog v-model="showModal" max-width="600px" persistent>
    <v-card>
      <v-card-title class="headline secondary white--text">
        Add User to Terminal
      </v-card-title>

      <v-card-text class="pt-4">
        <v-form ref="form" v-model="isFormValid">
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
                v-model="selectedUser"
                :items="availableUsers"
                item-text="display"
                item-value="id"
                label="Select User"
                prepend-icon="fa-user"
                box
                :loading="isLoadingUsers"
                :rules="[rules.required]"
                no-data-text="No available users for this account"
              >
                <template v-slot:item="{ item }">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ item.email }} | {{ item.position }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-select>
            </v-flex>

            <v-flex xs12 sm6>
              <v-checkbox
                v-model="isDefault"
                label="Set as default terminal"
                color="primary"
              ></v-checkbox>
            </v-flex>

            <v-flex xs12 sm6>
              <v-checkbox
                v-model="canCharge"
                label="Allow charging on this terminal"
                color="primary"
              ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="close">Cancel</v-btn>
        <v-btn
          color="primary"
          :disabled="!isFormValid || isProcessing"
          :loading="isProcessing"
          @click="addUser"
        >
          Add User
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Bus from '@/bus'
import ApiMixin from '@/mixins/api'

export default {
  name: 'AddUserModal',
  mixins: [ApiMixin],

  props: {
    value: {
      type: Boolean,
      default: false
    },
    terminalId: {
      type: [Number, String],
      required: true
    },
    terminalAccountId: {
      type: [Number, String],
      required: true
    },
    existingUserIds: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      isFormValid: false,
      isLoadingUsers: false,
      isProcessing: false,
      selectedUser: null,
      availableUsers: [],
      isDefault: true,
      canCharge: true,
      rules: {
        required: value => !!value || 'This field is required'
      }
    }
  },

  computed: {
    showModal: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },

  watch: {
    value (val) {
      if (val) {
        this.reset()
        this.loadUsers()
      }
    }
  },

  methods: {
    reset () {
      this.selectedUser = null
      this.isDefault = true
      this.canCharge = true
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },

    async loadUsers () {
      if (!this.terminalAccountId) {
        this.availableUsers = []
        return
      }

      this.isLoadingUsers = true
      try {
        let result = await this.api({
          method: 'get',
          url: '/users',
          params: {
            filter: { account_id: this.terminalAccountId },
            perPage: '*'
          }
        })

        // Filter out users already linked to this terminal
        let users = result.data.rows.filter(
          u => !this.existingUserIds.includes(u.id)
        )

        this.availableUsers = users.map(u => ({
          ...u,
          display: `${u.name} (${u.email})`
        }))
      } catch (error) {
        console.error('Error loading users:', error)
        this.availableUsers = []
      } finally {
        this.isLoadingUsers = false
      }
    },

    async addUser () {
      if (!this.selectedUser) return

      this.isProcessing = true
      try {
        await this.api({
          method: 'post',
          url: `/terminals/${this.terminalId}/users/${this.selectedUser}`,
          data: {
            is_default: this.isDefault,
            can_charge: this.canCharge
          }
        })

        Bus.$emit('openModal', {
          status: 'success',
          message: 'User added successfully'
        })

        this.$emit('added')
        this.close()
      } catch (error) {
        Bus.$emit('openModal', {
          status: 'error',
          message: (error.response && error.response.data && error.response.data.error) || 'Error adding user'
        })
      } finally {
        this.isProcessing = false
      }
    },

    close () {
      this.showModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/terminal/AddUserModal.vue